import React, { useRef } from 'react';
import './Join.css';
import emailjs from '@emailjs/browser';

const Join = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    
    console.log("Form data:", form.current); // Log form data to ensure it is being submitted

    emailjs
      .sendForm('service_9wua0yv', 'template_wf90a5r', form.current, {
        user_id: 'SrlnM_MWQq8SwYX7g',  // Ensure you are using the correct User ID
      })
      .then((result) => {
        console.log('Success:', result.text);  // Log success response
      })
      .catch((error) => {
        console.log('Error:', error.text);  // Log error response
      });
  };

  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">READY TO</span>
          <span>LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className="stroke-text">WITH US</span>
        </div>
      </div>
      <div className="right-j">
        <form ref={form} className="email-container" onSubmit={sendEmail}>
          <input
            type="email"
            name="user_email"  // Ensure that 'name' matches your template's expected variable name
            placeholder="Enter Your Email Address"
            required
          />
          <button className="btn btn-j">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
